import { render, staticRenderFns } from "./MessageGalleryLocked.vue?vue&type=template&id=c757a8d8&scoped=true&"
import script from "./MessageGalleryLocked.vue?vue&type=script&lang=ts&"
export * from "./MessageGalleryLocked.vue?vue&type=script&lang=ts&"
import style0 from "./MessageGalleryLocked.vue?vue&type=style&index=0&id=c757a8d8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c757a8d8",
  null
  
)

export default component.exports